/**
 * @returns {Object}
 */
export function ignoreMouseWheel() {
    
    return {
        restrict: 'A',
        link: (scope, element, attr, ctrl) => {
            
            element.bind('wheel', (event) => {
                
                event.preventDefault();
            });
        }
    };
}


// WEBPACK FOOTER //
// ./src/ui/directives/ignore-mouse-wheel.directive.js